var _ellipse, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFish1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 12.5,
    rx: 7,
    ry: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9L11 10L10 13L9 15.5L9.5 20L10 22.5L13.5 23.5L17.5 24L21 22.5L24.5 20.5L25.5 19V18H24.5L21 16.5L18.5 14.5L16.5 12L15.5 10V7.5L15 6.5H11L8 7.5L7.5 8.5L9.5 9Z",
    fill: "url(#paint0_linear_20_767)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1002 12.1004C28.1382 12.8395 28.0709 13.5803 27.9002 14.3004C27.5918 16.0023 26.9099 17.6146 25.9037 19.0214C24.8974 20.4281 23.5917 21.5942 22.0807 22.4358C20.5697 23.2774 18.8908 23.7735 17.165 23.8884C15.4393 24.0034 13.7095 23.7342 12.1002 23.1004C11.6054 22.9282 11.1349 22.6929 10.7002 22.4004L10.0002 22.0004C10.0002 21.9004 9.90019 21.8004 9.90019 21.7004C9.49848 20.6121 9.3002 18.3004 9.3002 18.3004C9.21826 18.0078 9.18448 17.1038 9.2002 16.8004C9.19214 14.3266 9.96173 11.9129 11.4002 9.9004C10.1649 9.255 8.7939 8.91226 7.40019 8.9004H6.7002C7.4467 8.11189 8.34591 7.48361 9.34305 7.05381C10.3402 6.62401 11.4144 6.40169 12.5002 6.4004C13.277 6.39483 14.0508 6.49576 14.8002 6.70039C16.6697 5.57081 18.816 4.98232 21.0002 5.0004C22.9868 4.98805 24.9454 5.4691 26.7002 6.4004C27.62 8.15958 28.1003 10.1153 28.1002 12.1004Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 22.0004L9.5 24.9004L9.2 27.9004L6.60001 25.3004L4 22.7004L7 22.4004L9.89999 22.0004Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1999 18.0004C23.3264 17.974 20.5796 16.814 18.557 14.7727C16.5344 12.7314 15.3998 9.97402 15.3999 7.1004",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.4004C22.2075 10.4004 22.7 9.9079 22.7 9.30038C22.7 8.69287 22.2075 8.20038 21.6 8.20038C20.9925 8.20038 20.5 8.69287 20.5 9.30038C20.5 9.9079 20.9925 10.4004 21.6 10.4004Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_767",
    x1: 10.266,
    y1: 29.2708,
    x2: 23.5148,
    y2: 9.88555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BADF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish1);
export default __webpack_public_path__ + "static/media/fish 1.a19f44c86939032444b89ff9a31c0dc5.svg";
export { ForwardRef as ReactComponent };